import React from 'react';
import { ActualiteContextProvider } from './contexts/actualiteContext';
import { AuthContextProvider } from './contexts/authContext';
import { DocumentContextProvider } from './contexts/documentContext';
import { IntervenantContextProvider } from './contexts/intervenantContext';
import { LotCommercialContextProvider } from './contexts/lotCommercialContext';
import { LotContextProvider } from './contexts/lotContext';
import { MessageContextProvider } from './contexts/messageContext';
import { NotificationContextProvider } from './contexts/notificationContext';
import { ReglementContextProvider } from './contexts/reglementContext';
import { ResponsiveContextProvider } from './contexts/responsiveContext';
import { StadeContextProvider } from './contexts/stadeContext';
import { TchatContextProvider } from './contexts/tchatContext';
import { UserContextProvider } from './contexts/userContext';

// Tuto : https://javascript.plainenglish.io/how-to-combine-context-providers-for-cleaner-react-code-9ed24f20225e

const combine = (...providers) => {
    return providers.reduce(
        (AccumulatedComponents, CurrentComponent) => {
            return ({ children }) => {
                return (
                    <AccumulatedComponents>
                        <CurrentComponent>{children}</CurrentComponent>
                    </AccumulatedComponents>
                );
            };
        },
        ({ children }) => <>{children}</>,
    );
};

const providers = [
    NotificationContextProvider, // En premier car utilis� presque partout
    ResponsiveContextProvider, // En second, tr�s utilis� �galement
    UserContextProvider,
    LotCommercialContextProvider,
    DocumentContextProvider,
    LotContextProvider,
    MessageContextProvider,
    ActualiteContextProvider,
    IntervenantContextProvider,
    StadeContextProvider,
    ReglementContextProvider,
    AuthContextProvider, // Dans les derniers car consomme une majorit� des contexts
    TchatContextProvider, // En dernier car doit savoir si utilisateur authentifi� ou non
];

export const AppContextProvider = combine(...providers);